export const setUrlId = (path: string, key: string, id: number):string => {
  const regExp = new RegExp(`:${key}`, 'g')
  return path.replace(regExp, id.toString())
}

export const setUrlParam = (path: string, params: { key: string, value: string }[]):string => {
  let url = path
  for (let i = 0;i < params.length;i += 1) {
    const regExp = new RegExp(`:${params[i].key}`, 'g')
    url = url.replace(regExp, params[i].value)
  }
  return url
}

export const getPathWithoutLang = (path: string): string => path.replace(/\/(ja|en)/, '')

export const setLangParamPath = (path: string, lang: string):string => {
  const pathWithoutLang = getPathWithoutLang(path)
  return `/${lang}${pathWithoutLang}`
}

export const setPath = (path: string, lang: string):string => `/${lang}${path}`

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getGetPrams = (_urlSearch: string) => {
  const urlSearch = _urlSearch.substring(1)

  return urlSearch.split('&').reduce((result, param) => {
    const temp = param.split('=')
    return {
      ...result,
      [temp[0]]: temp[1],
    }
  }, {})
}

export const openNewTab = (url: string, method: string):Window | null => {
  const win = window.open("about:blank", "newTab")

  const form = document.createElement("form")
  form.target = "newTab"
  form.action = url
  form.method = method

  const body = document.getElementsByTagName("body")[0]
  body.appendChild(form)
  form.submit()
  body.removeChild(form)
  return win
}
